import { SubscriptionStatus } from '@global/types/types';

export const existSubscriptionStatus: string[] = [
  SubscriptionStatus.Placed,
  SubscriptionStatus.Paid,
];
